"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html lang="fr">
      <body className="bg-slate-50 font-sans antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
          <h1 className="text-xl font-semibold text-slate-900">Erreur de l&apos;application</h1>
          <p className="max-w-md text-center text-sm text-slate-600">
            {error.message || "Une erreur critique s&apos;est produite. Rechargez la page."}
          </p>
          <button
            type="button"
            onClick={() => reset()}
            className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
          >
            Recharger
          </button>
        </div>
      </body>
    </html>
  );
}
